/**
 * As provas atendidas. O id é o valor de `VITE_TENANT` e o nome do target de
 * hosting em `firebase.json`.
 *
 * **Arquivo sem import nenhum de propósito**: o `vite.config.ts` o lê para
 * validar `VITE_TENANT` antes do build, e ali não há alias `@/` nem loader de
 * asset. Prova nova entra aqui, em `data/tenants.ts`, nos scripts do
 * `package.json` e em `firebase.json`/`.firebaserc`.
 */
export const TENANT_IDS = ['amrigs', 'psu-mg', 'scmbh', 'hcpa'] as const;

export type TenantId = (typeof TENANT_IDS)[number];

export function isTenantId(value: unknown): value is TenantId {
  return TENANT_IDS.includes(value as TenantId);
}

/**
 * O nome da variável de uma prova: `('VITE_GTM_ID', 'psu-mg')` →
 * `VITE_GTM_ID_PSU_MG`. Uma por prova, e não uma só, para que o `.env.prod`
 * guarde as cinco lado a lado e o build de uma prova nunca pegue a de outra.
 */
export function tenantEnvKey(prefix: string, tenant: TenantId): string {
  return `${prefix}_${tenant.toUpperCase().replace(/-/g, '_')}`;
}
